<template>
  <div class="plan-table">
    <el-table
      :data="viewModel"
      :span-method="arraySpanMethod"
      :row-class-name="generateGrayRow"
      header-cell-class-name="white-bg"
      cell-class-name="gray-border"
      style="width: 100%;"
    >
      <el-table-column
        prop="groupName"
        label="方案名称"
        :span="2"
        class-name="gray-bg gray-border-left"
        width="100"
      >
      </el-table-column>
      <el-table-column prop="name" width="200" class-name="gray-border-right">
        <template slot-scope="scope">
          {{ scope.row.name || scope.row.subGroupName || '--' }}
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in model"
        :key="item.programmeId + '-' + index"
        :prop="'plan-' + index + '-' + item.programmeId"
        width="220"
        align="center"
        class-name="gray-border"
      >
        <template slot="header">
          <template v-if="editable">
            <div v-if="item.programmeId" class="plan-column-header">
              <i
                v-if="index !== 0"
                class="QS-icon-close"
                style="cursor: pointer"
                @click="removePlan(index, item.programmeId)"
              >
              </i>
              <div class="plan-column-header-name">
                {{ item.programmeName }}
              </div>
              <planSelector
                :show="item.showOptions"
                btnName="更换方案"
                :leaseType="leaseType"
                @confirmPlan="
                  (planId) => modifyPlan(planId, index, item.programmeId)
                "
              />
            </div>
            <planSelector
              v-else
              :show="item.showOptions"
              btnName="选择方案"
              :leaseType="leaseType"
              @confirmPlan="
                (planId) => modifyPlan(planId, index, item.programmeId)
              "
            />
          </template>
          <div v-else class="plan-column-header-name">
            {{ item.programmeName }}
          </div>
        </template>
        <template
          slot-scope="scope"
          v-if="
            scope.row['plan-' + index + '-' + item.programmeId] !== undefined
          "
        >
          <template v-if="editable">
            <div
              class="el-input"
              style="width: 170px"
              v-if="scope.row.editable"
            >
              <input
                v-if="scope.row.percent"
                v-number:percent.max100
                class="el-input__inner"
                v-model="scope.row['plan-' + index + '-' + item.programmeId]"
              />
              <input
                v-else
                v-number:money
                class="el-input__inner"
                v-model="scope.row['plan-' + index + '-' + item.programmeId]"
              />
            </div>
            <span v-else>{{
              scope.row['plan-' + index + '-' + item.programmeId]
            }}</span>
          </template>
          <span v-else>
            {{ scope.row['plan-' + index + '-' + item.programmeId] }}
            <el-button
              v-if="
                showCooperateBtn(scope.$index, item.programmeId) &&
                judgePermission('car_resource_message_add')
              "
              type="primary"
              @click="cooperate(item.programmeId)"
              >合作咨询</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <cooperateDialog
      :show.sync="showCooperateDialog"
      :planId="cooperatePlanId"
    />
  </div>
</template>

<script>
import { calculate } from '@/api/carResource/index'
import planSelector from './planSelector.vue'
import cooperateDialog from './cooperateDialog.vue'

export default {
  name: 'planTable',
  components: {
    planSelector,
    cooperateDialog,
  },
  props: {
    // 表头格式
    schema: {
      type: Array,
      default: () => [],
    },
    // 默认方案
    defaultPlans: {
      type: Array,
      default: () => [],
    },
    // 全量方案列表 子组件向父组件传值使用
    // eslint-disable-next-line vue/no-unused-properties
    plans: {
      type: Array,
      default: () => [],
    },
    // 是否可编辑
    editable: {
      type: Boolean,
      default: true,
    },
    // 方案类型：经租、融租
    leaseType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // 原始数据，用于定义表格列
      model: [],
      // 视图数据，用于填充表格内容
      viewModel: this.defaultPlans,
      // 展示合作弹窗
      showCooperateDialog: false,
      // 合作方案ID
      cooperatePlanId: null,
    }
  },
  watch: {
    defaultPlans(newVal) {
      const count = newVal.length
      if (count !== 0) {
        this.model = []
        newVal.forEach((item, index) => {
          if (item.programmeId) {
            this.addPlan(item, index)
          } else {
            this.$set(this.model, index, {})
          }
        })
      }
    },
    schema: {
      handler(newVal) {
        if (newVal.length !== 0) {
          this.viewModel = newVal
        }
      },
      immediate: true,
    },
  },
  computed: {
    // 行列合并计算
    levels() {
      const result = {
        rowspan: {},
        colspan: [],
      }
      this.schema.forEach((item, index) => {
        // 处理行合并
        if (!result.rowspan[item.groupCode]) {
          result.rowspan[item.groupCode] = {}
          result.rowspan[item.groupCode].startIndex = index
          result.rowspan[item.groupCode].mergeRows = 1
        } else {
          result.rowspan[item.groupCode].mergeRows += 1
        }
        // 处理列合并
        if (!item.code) {
          result.colspan.push(index)
        }
      })
      return result
    },
  },
  methods: {
    /**
     * 计算合并行列
     */
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 第一级合并计算行数
        for (const i in this.levels.rowspan) {
          if (Object.hasOwnProperty.call(this.levels.rowspan, i)) {
            const { startIndex, mergeRows } = this.levels.rowspan[i]
            if (rowIndex === startIndex) {
              return [mergeRows, 1]
            } else if (
              rowIndex > startIndex &&
              rowIndex < startIndex + mergeRows
            ) {
              return [0, 0]
            }
          }
        }
      } else if (columnIndex === 1 && this.levels.colspan.includes(rowIndex)) {
        // 第二级合并计算列数
        return [1, 5]
      } else if (this.levels.colspan.includes(rowIndex)) {
        return [0, 0]
      }
    },
    // 是否展示合作按钮
    showCooperateBtn(index, id) {
      const hasPlan = this.model.some((item) => item.programmeId === id)
      return hasPlan && index === this.viewModel.length - 1
    },
    // 行背景置灰
    generateGrayRow({ row }) {
      if (
        !this.model.some(
          (item, index) =>
            row[`plan-${index}-${item.programmeId}`] !== undefined && row.code,
        )
      ) {
        return 'gray-bg'
      }
    },
    // 删除方案
    removePlan(index, id) {
      this.model[index] = {}
      this.removeViewModel(index, id)
      this.$emit('update:plans', this.viewModel)
    },
    // 修改方案
    modifyPlan(newId, index, oldId) {
      calculate({
        carNum: 1,
        programmeList: [{ programmeId: newId }],
      }).then((res) => {
        if (res.code === 1) {
          this.removeViewModel(index, oldId)
          this.addPlan(res.data.programmeList[0], index)
        }
      })
    },
    // 方案数据Array2Map
    arr2map(planModelList) {
      const result = {}
      planModelList.forEach((item) => {
        result[item.code] = item.amountString
      })
      return result
    },
    // 删除viewModel中的方案
    removeViewModel(index, id) {
      this.viewModel.forEach((item, i) => {
        if (item.subGroupCode) {
          delete item[`plan-${index}-${id}`]
          this.$set(this.viewModel, i, item)
        }
      })
    },
    // 添加model
    addPlan(planData, index) {
      this.$set(this.model, index, {
        ...planData,
        // 是否展示方案级联选择器
        showOptions: false,
      })
      const { programmeId, itemList = [] } = planData
      const dataMap = this.arr2map(itemList)
      for (let i = 0, len = this.viewModel.length; i < len; i++) {
        const item = this.viewModel[i]
        if (item.subGroupCode) {
          item[`plan-${index}-${programmeId}`] = dataMap[item.code]
        }
      }
      this.$emit('update:plans', this.viewModel)
    },
    // 合作咨询
    cooperate(planId) {
      this.showCooperateDialog = true
      this.cooperatePlanId = planId
    },
  },
}
</script>
<style scoped lang="scss">
.plan-table {
  height: 100%;
}
::v-deep .gray-bg {
  background-color: #f7f8fa;
}

::v-deep .overflow-hidden {
  overflow: hidden;
}

::v-deep .white-bg {
  background-color: #fff !important;
}

::v-deep .gray-border {
  border: solid 1px #ebedf0 !important;

  .cell {
    overflow: hidden;
  }
}

::v-deep .gray-border-left {
  border-top: solid 1px #ebedf0 !important;
  border-left: solid 1px #ebedf0 !important;
}

::v-deep .gray-border-right {
  border-top: solid 1px #ebedf0 !important;
  border-right: solid 1px #ebedf0 !important;
}

::v-deep .el-table .el-table__body {
  border-bottom: solid 1px #ebedf0 !important;
}

.plan-column-header {
  position: relative;

  .QS-icon-close {
    position: absolute;
    top: 0;
    right: -6px;
  }

  .plan-column-header-name {
    padding: 0 8px;
  }
}
</style>
